import { useEffect, useState } from "react"
import { useAppState } from "../../context/appStateContext"
import CloseButton, { CloseButtonProps } from "../CloseButton/CloseButton"
import styles from "./FixedCloseButton.module.scss"

interface FixedCloseButtonProps extends CloseButtonProps {
  topInset?: number
}

const FixedCloseButton = ({
  topInset = 0,
  ...props
}: FixedCloseButtonProps) => {
  const { state } = useAppState()
  const [hideOnLoaded, setHideOnLoaded] = useState(true)

  const fadeTime = state.productData?.closeFadeTime ?? 0

  useEffect(() => {
    if (state.fullyLoaded && fadeTime > 0) {
      const timer = setTimeout(() => {
        setHideOnLoaded(false)
      }, 1000 * fadeTime)

      return () => clearTimeout(timer)
    }
  }, [state.fullyLoaded, fadeTime])

  let shouldShow = !hideOnLoaded && state.fullyLoaded
  shouldShow = shouldShow || fadeTime === 0

  const visibilityStyle = shouldShow ? styles.visible : styles.hidden

  return (
    <div
      className={`${styles.fixedContainer} ${visibilityStyle}`}
      style={{ top: `${topInset}px` }}
    >
      <CloseButton
        {...props}
        className={`${styles.button} ${props.className ?? ""}`}
      />
    </div>
  )
}

export default FixedCloseButton
